export default __webpack_public_path__ + "static/media/tourismCouncil.8b6131cd.svg";